import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

const MainLayout = () => {
  return (
    <>
      <NavBar></NavBar>
      <Outlet></Outlet>
      <footer>
        <Footer></Footer>
      </footer>
      <div style={{ height: "100px" }}></div>
    </>
  );
};

export default MainLayout;
